import { React, useEffect } from "react";
import PropTypes from "prop-types";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import TaskDynamicFieldsInput from "../Input/TasksDynamicFieldsInput";
import {
  isDynamicFieldValid,
  isMaskValid,
  isRegexValid,
  FIELD_TYPES,
} from "../utils/utils";
import ClearFiltersActive from "../../../../assets/icons/ClearFiltersActive-32px-Blue-60.svg";
import ClearFiltersDisabled from "../../../../assets/icons/ClearFiltersDisabled-32px-Gray-70.svg";
import ExportButton from "../../../../assets/icons/Export-Blue-20px.svg";
import { ExportDynamicTable } from "../../../../services/api/dynamic-fields-api";
import { saveAs } from "file-saver";
import dayjs from "../../../../util/dayjs-config";

const ExportToExcel = (field, taskWithWorkflow, isForm, taskId) => {
  if (!isForm) {
    let data = {
      DynamicFieldId: field.Id,
      WorkbookName: field.Label,
      ObjectId: taskWithWorkflow.Id,
    };
    ExportDynamicTable(data).then((result) =>
      saveAs(
        result,
        taskWithWorkflow.Name +
          "-" +
          data.WorkbookName +
          "-" +
          dayjs(new Date()).format("MM/DD/YYYY-h:mm a") +
          ".xlsx"
      )
    );
  } else {
    let data = {
      DynamicFieldId: field.DynamicFieldId,
      WorkbookName: field.LocalLabel,
      ObjectId: taskId,
    };
    ExportDynamicTable(data).then((result) =>
      saveAs(
        result,
        data.WorkbookName +
          "-" +
          dayjs(new Date()).format("MM/DD/YYYY-h:mm a") +
          ".xlsx"
      )
    );
  }
};

const TaskDynamicFieldsForm = (props) => {
  const {
    field,
    disabled,
    handleChange,
    disableErrors,
    setDynamicFields,
    taskWithWorkflow,
    disabledAddDelete,
    isForm,
    taskId,
  } = props;  

  return (
    <div className="tasks-dynamic-fields-wrapper">      
        <Form.Group
          className={`${field.CssClass ?? ""} ${disabled ? "disabled" : ""}`}
        >
          <DynamicFieldsFormInputLabel field={field} />
          {field.FieldType === FIELD_TYPES.table && (
            <div className="clearAllFiltersContainer">
              <OverlayTrigger
                placement={"top"}
                delay={{ show: 150, hide: 150 }}
                overlay={<Tooltip>Export Table</Tooltip>}
              >
                <div
                  className="clearFiltersButton"
                  onClick={() =>
                    ExportToExcel(field, taskWithWorkflow, isForm, taskId)
                  }
                >
                  <img src={ExportButton} alt="Export Data" />
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                placement={"top"}
                delay={{ show: 150, hide: 150 }}
                overlay={<Tooltip>Clear all filters</Tooltip>}
              >
                <div
                  id={"clearFilters-" + field.Id}
                  className="clearFiltersButton"
                >
                  <img
                    id={"clearFilters-" + field.Id + "-active"}
                    className="clearFiltersBtnHidden"
                    src={ClearFiltersActive}
                    alt="Clear Filters"
                  />
                  <img
                    id={"clearFilters-" + field.Id + "-disabled"}
                    className="clearFiltersBtnShowed"
                    src={ClearFiltersDisabled}
                    alt="Clear Filters"
                  />
                </div>
              </OverlayTrigger>
            </div>
          )}
          <TaskDynamicFieldsInput
            field={field}
            handleChange={handleChange}
            disableErrors={disableErrors}
            disabled={disabled}
            setDynamicFields={setDynamicFields}
            taskWithWorkflow={taskWithWorkflow}
            disabledAddDelete={disabledAddDelete}
            isForm={isForm}
          />
          {!disableErrors && (
            <Form.Control.Feedback type="invalid" className="d-block">
              <DynamicFieldsFormInputFeedback field={field} />
            </Form.Control.Feedback>
          )}
        </Form.Group>
    </div>
  );
};

const DynamicFieldsFormInputLabel = (props) => {
  const { field } = props;

  const label =
    field.FieldType === FIELD_TYPES.toggle ? (
      ""
    ) : (
      <Form.Label>
        {field.Label}
        <span className="red">{field.Required ? " *" : null}</span>
      </Form.Label>
    );

  if (field.FieldHelp) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{field.FieldHelp}</Tooltip>}
      >
        {label}
      </OverlayTrigger>
    );
  }

  return label;
};

const DynamicFieldsFormInputFeedback = (props) => {
  const { field } = props;

  if (!isMaskValid(field)) {
    return "Must follow the format: " + field.FieldMask;
  } else if (!isRegexValid(field)) {
    return field.FieldRegexDescription;
  } else if (!isDynamicFieldValid(field)) {
    return field.FieldType === FIELD_TYPES.table
      ? "Please add at least one row with values."
      : "Field is Required";
  } else {
    return null;
  }
};

TaskDynamicFieldsForm.propTypes = {
  field: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleChange: PropTypes.func,
  disableErrors: PropTypes.bool,
  setDynamicFields: PropTypes.func,
  taskWithWorkflow: PropTypes.object,
  disabledAddDelete: PropTypes.bool,
};

export default TaskDynamicFieldsForm;
